import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as FilterActions from '@core/actions/filter.actions';
import * as ProductActions from '@core/actions/product.actions';
import { FormControl } from '@angular/forms';
import { AdvancedFilterComponent } from '@app/modules/shared/advanced-filter/advanced-filter.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, takeWhile, isEmpty } from 'rxjs/operators';
import * as fromRoot from '@core/reducers/root.reducer';
import * as fromProduct from '@core/reducers/product.reducer';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductFilterComponent implements OnInit, OnDestroy {
  me$ = this.store.pipe(select(fromRoot.getMe));
  filter$ = this.store.pipe(select(fromProduct.getFilters));

  @Input()
  advancedFilters = [];

  @Input()
  followId;

  @Output()
  filters = new EventEmitter();

  @Output()
  searchControl = new EventEmitter();

  @Input()
  products;

  @Input()
  followType

  filt = [];
  search;
  _alive = true;
  _modalRef;
  role;
  constructor(private store: Store<any>, private modal: NgbModal) { }

  ngOnInit() {
    // console.log('sadas', this.followId);
    this.store.select(fromProduct.getFilters).subscribe(item => {
      if (item && item.length) {
        item.forEach(value => {
          this.filt.push({
            key: value.condition,
            value: value.valueCondition
          });
        }),
          this.store.dispatch(
            new ProductActions.Search(this.filt, this.followId)
          );
        this.filt = [];
      }

    });
    this.search = new FormControl();
    this.search.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        takeWhile(() => this._alive)
      )
      .subscribe(term => {
        if (!term) {
          this.searchControl.emit(term);
        }
      });
    this.me$.pipe(takeWhile(() => this._alive)).subscribe(me => {
      this.role = me && me.role;
    });
  }

  basicSearch(e) {
    this.searchControl.emit(e);
  }

  keyDownFunction(event, e) {
    if (event.keyCode == 13) {
      this.searchControl.emit(e);
    }
  }

  ngOnDestroy() {
    if (this._modalRef) {
      this._modalRef.close();
    }
    this._alive = false;
  }

  isClothing() {
    if (this.followType === 'VESTUARIO') {
      return true
    }
    return false
  }

  openModal() {
    this._modalRef = this.modal.open(AdvancedFilterComponent);
    this._modalRef.componentInstance.title = 'Filtro avanzado';
    this._modalRef.componentInstance.FollowId = this.followId;
    // this._modalRef.componentInstance.advancedFilters = this.advancedFilters;
    this._modalRef.componentInstance.products = this.products;
    this._modalRef.result.then(
      result => {
        // do nothing
      },
      confirmed => {
        if (confirmed) {
          // this.advancedFilters = confirmed;
          // this.filter.emit(confirmed);
          //this.store.dispatch(
          //new ProductActions.LoadByFollow(this.followId, {
          //condition: confirmed.condition,
          //valueCondition: confirmed.valueCondition,
          //type: 'minimal'
          //})
          //);

          // this.store.dispatch(
          //   new ProductActions.Search([
          //     {
          //       key: confirmed.condition,
          //       value: confirmed.valueCondition
          //     }
          //   ], this.followId)
          // );

          this.filters.emit(confirmed);
        }
      }
    );
  }

  get isRegionalBuyer() {
    return this.role === 'regional-buyer';
  }
  get isPlanner() {
    return rolesUtils.isPlanner(this.role);
  }
}
